<template>
<!--   <div class="py-1">
    <b-row>
      <b-col cols="12" class="px-3">
      </b-col>
      <b-col cols="12" class="px-3">
        <SearchableChart :convertToChartData="convertToChartData" :charts="charts"></SearchableChart>
      </b-col>
    </b-row>
    <b-row style="min-height: 45vh">
      <b-col cols="6" class="p-3">
        <BulletinList></BulletinList>
      </b-col>
      <b-col cols="6" class="p-3">
        <NotificationTabContainer></NotificationTabContainer>
      </b-col>
    </b-row>
  </div> -->




</template>
<script>
import {
  BulletinList,
  NotificationTabContainer,
  FycTrend
} from '../components'


import moment from 'moment'
import {
  SearchableChart
} from '../components'

import { DashboardComponents } from '@/components'
import Cookies from 'js-cookie'

export default {
  name: 'Dashboard',
  components: {
    DashboardComponents,
    BulletinList,
    NotificationTabContainer,
    SearchableChart,
    FycTrend
  },
  created() {
    // let permissionLevel = Cookies.get('permissionLevel');
    // if (permissionLevel == 7){
    //   this.$router.replace('/customer-dashboard');
    // }
  },
  data() {
    return {
      charts: [
        'casesTrend',
        'fycTrend',
        'casesByProvider',
        'commissionByProvider',
        'commissionByAgent',
        'fycByAgent',
        'commissionTrend'
      ]
    }
  },
  methods: {
    convertToChartData(data, type, y, x, startDate, endDate, fillEmpty = false) {
      if (fillEmpty) {
        data = this.fillEmptyMonth(
          startDate,
          endDate,
          data,
          type,
          x
        );
      }

      let color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
      let labels = data.map(ct => ct[x]);
      let datasets = [{
        label: this.$t(`home.dashboard.chart.unit.${type}`),
        backgroundColor: color,
        data: data.map(ct => ct[y]),
        borderColor: color,
        fill: false
      }]

      return {
        labels: labels,
        datasets: datasets
      }
    },

    fillEmptyMonth(dateFrom, dateTo, result, type, x) {
      var dateFrom = moment(dateFrom);
      var dateTo = moment(dateTo);

      dateFrom = dateFrom.startOf('month');
      dateTo = dateTo.startOf('month');

      var interval = dateTo.diff(dateFrom, 'month', true);
      var currentMonth = dateFrom;

      var converted = [];
      for (let i = 0; i < (interval + 1); i++) {
        let given = result.filter((r) => {
          return r[x] === currentMonth.format('YYYY-MM')  
        });
        if (given.length === 0) {
          given = {
            date: currentMonth.format('YYYY-MM')
          }

          switch (type) {
            case this.charts[0]:
              given['cases'] = 0;
              break;
            case this.charts[1]:
              given['commission'] = 0;
              break;
            case this.charts[6]:
              given['commission'] = 0;
              break;
          }
        } else {
          given = given[0]
        }

        // console.debug('given', given);
        converted.push(given);

        currentMonth.add(1, 'month');
      }

      return converted;
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/containers/Dashboard.vue